import React from "react";
import "./WorkSpaces.scss";
import { MotifButton, MotifChip } from "@ey-xd/motif-react";
import { useNavigate } from "react-router-dom";
import { workspaces } from '../constants/workspaces'
import hexDice from '../assets/media/images/hexagon-dice.png'

const WorkSpaces = () => {

    const navigate = useNavigate()

    const navigateToDetails = (index) => {
        navigate(`./${index}`);
    }
    return (
        <div className="mainWrapper">
            <div className="title">
                <div className="text">
                    Client Technology Consulting Cyber AI
                </div>
                <div>
                    Search through a repository of workspaces what meets your
                    business needs
                </div>
            </div>
            <div className="newAssetButton">
                {/* <MotifButton>New Asset</MotifButton> */}
            </div>
            <div className="cardsWrapper">
                {
                    workspaces.map((card, index) => {
                        return (
                            <div className="card">
                                <div className="cardHeader">
                                    <img src={hexDice} />
                                    <span style={{ marginLeft: 8 }}>{card.header}</span>
                                </div>
                                <div className="cardContent">
                                    <div className="chipWrapper">
                                        <MotifChip>Consulting</MotifChip>
                                        <MotifChip>AI</MotifChip>
                                    </div>
                                    <div style={{ paddingTop: 16 }}>
                                        {card.content}
                                    </div>
                                </div>
                                <div className="cardFooter">
                                    <MotifButton variant="secondary" onClick={() => navigateToDetails(index)}>View</MotifButton>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
};

export default WorkSpaces;
